import { render, staticRenderFns } from "./cookieText.vue?vue&type=template&id=41464a52&scoped=true&"
import script from "./cookieText.vue?vue&type=script&lang=js&"
export * from "./cookieText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41464a52",
  null
  
)

export default component.exports